import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { withUAPLThemedStyles } from '../with-themed-styles';
import { getPlacementCardStyles } from '../styles';
import type { UAPPlacementComponentProps } from '../@types';

const MMAPlacementCardImpl = ({
  isEnabled,
  url,

  // in pixel
  width,

  // in pixel
  height,

  children,
  mmaPlacementCardClassName,
  ariaLabel,
  classes,
  isAdPreviewRefreshEnabled,
}: UAPPlacementComponentProps) => {
  const styles = useMemo(() => ((width || height) ? ({
    width: width ? `${width}px` : undefined,
    height: height ? `${height}px` : undefined,
  }) : undefined), [height, width]);

  return (
    <div style={styles} className={classnames(isAdPreviewRefreshEnabled ? classes.mmaRefreshedPlacementCardRoot : classes.mmaPlacementCardRoot, !isEnabled && classes.mmaPlacementCardDisabled, mmaPlacementCardClassName, 'ad-placement-card-preview')}>
      {url && (
        <a
          className="placement-card-content"
          target="_blank"
          rel="noopener noreferrer"
          href={url}
          aria-label={ariaLabel}
        >
          {children}
        </a>
      )}
      {!url && (
        <div
          className="placement-card-content"
          role={ariaLabel ? 'group' : undefined}
          aria-label={ariaLabel}
        >
          {children}
        </div>
      )}
    </div>
  );
};

MMAPlacementCardImpl.propTypes = {
  isEnabled: PropTypes.bool,
  url: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  children: PropTypes.node.isRequired,
  mmaPlacementCardClassName: PropTypes.string,
  ariaLabel: PropTypes.string,
  classes: PropTypes.shape({
    mmaPlacementCardRoot: PropTypes.string,
    mmaPlacementCardDisabled: PropTypes.string,
  }).isRequired,
};

MMAPlacementCardImpl.defaultProps = {
  isEnabled: true,
  url: undefined,
  width: undefined,
  height: undefined,
  mmaPlacementCardClassName: undefined,
  ariaLabel: undefined,
};

export const MMAPlacementCard = withUAPLThemedStyles(
  MMAPlacementCardImpl,
  getPlacementCardStyles,
  { componentName: 'MMAPlacementCard ' }
);
